export const THIS_YEAR = new Date().getFullYear();
export const EMAIL_ME = 'info@milanesieditore.it';
export const PHONE_ME = '0424 285835';
export const LIB_URL = 'https://librerie-sitiweb.milanesieditore.it';